import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HubHookFormInput } from "../../components";

export const StyledTitleStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: "25px",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px",
  borderBottom: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
}));

export const StyledEditorStack = styled(Stack)(({ theme }) => ({
  height: "calc(100vh - 102px)",
  flexDirection: "row",
  overflow: "hidden",
}));

export const StyledInput = styled(HubHookFormInput)({
  width: 250,
  padding: "5px 10px",
  borderRadius: 6,
});

export const StyledBackgroundStack = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  justifyContent: "start",
  alignItems: "center",
  overflow: "auto",
  padding: "50px",
  backgroundColor: theme.palette.hubColors.blueMainTransparent?.replace(
    "0.1",
    "0.025"
  ),
  backgroundImage: "radial-gradient(#999 1px, transparent 0)",
  backgroundSize: "20px 20px",
  backgroundRepeat: "repeat",
  "::-webkit-scrollbar": {
    display: "none",
  },
  "@media print": {
    ".MuiInputBase-root": {
      backgroundColor: "transparent !important",
    },
  },
}));

export const StyledLabelStack = styled(Stack)(({ theme }) => ({
  // boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.2)",
  gap: "5px",
}));